import ai from './ai.json';
import broadcasts from './broadcasts.json';
import callCenter from './callCenter.json';
import cannedFiles from './cannedFiles.json';
import channels from './channels.json';
import closingNotes from './closingNotes.json';
import contacts from './contacts.json';
import conversations from './conversations.json';
import customAttributes from './customAttributes.json';
import Dashboard from './Dashboard.json';
import generalSetting from './general-setting.json';
import global from './global.json';
import integrations from './integrations.json';
import notifications from './notifications.json';
import reports from './reports.json';
import responses from './responses.json';
import roles from './roles.json';
import survey from './survey.json';
import tags from './tags.json';
import Teams from './Teams.json';
import Users from './Users.json';
import workflow from './workflow.json';

export default {
  ...global,
  ...Dashboard,
  ...Teams,
  ...Users,
  ...tags,
  ...channels,
  ...contacts,
  ...conversations,
  ...cannedFiles,
  ...responses,
  ...roles,
  ...closingNotes,
  ...broadcasts,
  ...integrations,
  ...workflow,
  ...reports,
  ...notifications,
  ...customAttributes,
  ...survey,
  ...generalSetting,
  ...ai,
  ...callCenter,
};
